import { useState, useEffect } from "react";

export const useMediaQuery = (query) => {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);
		setMatches(mediaQuery.matches);

		const handler = (event) => setMatches(event.matches);
		mediaQuery.addEventListener("change", handler);

		return () => mediaQuery.removeEventListener("change", handler);
	}, [query]);

	return matches;
};

// 미디어 쿼리 breakpoint 상수
export const BREAKPOINTS = {
	MOBILE: "(max-width: 581px)",
	TABLET: "(max-width: 1400px)",
};
